import React from "react"

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="flex-grid">
          <div>
            <div className="copyright">
              &copy;{new Date().getFullYear()} Governors Point Land LP
            </div>
          </div>
          <div className="contact contact-press">
            <div>
              <span className="title">Press</span>
            </div>
            <a href="mailto:b@thelast.agency">b@thelast.agency</a>
          </div>
          <div className="contact">
            <div>
              <span className="title">Sales</span>
            </div>
            <a href="mailto:info@governorspoint.org">info@governorspoint.org</a>
            <a href="tel:13605990379">+1 360 599 0379</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
